import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppStore } from './store';
import { DegenCollectionNames, collectionConstMapping, DegenCollectionNamesArr } from '../constants/collections';

import { AppConfig, UserSession, showConnect } from '@stacks/connect';
const appConfig = new AppConfig(['store_write', 'publish_data']);
export const userSession = new UserSession({ appConfig });

export type IWallet = string;
export type ISelectedNftNr = string;

interface ISelectedNft {
  nftName: string;
  collectionName: string;
  nftNr: string;
  nftImg: string;
}

export interface UserStore {
  loggedIn: boolean;
  accountAddress: string | null;
  accountAddressShort: string | null;
  selectedNft?: ISelectedNft;
}

const initialState: UserStore = {
  loggedIn: false,
  accountAddress: null,
  accountAddressShort: null,
};

export const Slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logIn: (state: UserStore, action: PayloadAction<IWallet>) => {
      let wallet = action.payload;

      return {
        loggedIn: true,
        accountAddress: wallet,
        accountAddressShort: wallet.slice(0, 4) + '...' + wallet.slice(wallet.length - 4, wallet.length),
      };
    },
    logOut: (state) => {
      return initialState;
    },
    selectNft: (state: UserStore, action: PayloadAction<ISelectedNftNr>) => {
      let nftName = action.payload;
      let nftCollectionName = nftName.split('#')[0],
        nftNr = nftName.split('#')[1];

      if (DegenCollectionNamesArr.includes(nftCollectionName))
        return {
          ...state,
          selectedNft: {
            nftName,
            nftNr,
            collectionName: nftCollectionName,
            nftImg: collectionConstMapping[nftCollectionName as DegenCollectionNames].baseSource + nftNr + '.png',
          },
        };
      else return state;
    },
  },
});

export const selectUserStore = (state: AppStore) => state.userStore;
export const selectLoggedIn = createSelector(selectUserStore, (state: UserStore) => state.loggedIn);
export const selectAddressShort = createSelector(selectUserStore, (state: UserStore) => state.accountAddressShort);
export const selectAddress = createSelector(selectUserStore, (state: UserStore) => state.accountAddress);
export const selectNftSelected = createSelector(selectUserStore, (state: UserStore) => state.selectedNft);

export const { logIn, logOut, selectNft } = Slice.actions;
export default Slice.reducer;
